import React from 'react';
import { Helmet } from 'react-helmet-async';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSchemaProps {
  faqs: FAQItem[];
  pageUrl?: string;
}

/**
 * FAQSchema component for implementing FAQ structured data
 * This helps Google display FAQ snippets in search results
 */
const FAQSchema: React.FC<FAQSchemaProps> = ({ 
  faqs, 
  pageUrl = typeof window !== 'undefined' ? window.location.href : 'https://qualityaivoice.com' 
}) => {
  // Generate FAQ structured data
  const faqStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': faqs.map(faq => ({
      '@type': 'Question',
      'name': faq.question,
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': faq.answer
      }
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(faqStructuredData)}
      </script>
    </Helmet>
  );
};

export default FAQSchema; 